// "Checklists from this manual" on a manual's page (fixes-2 part 2), next to "Risk assessments in this manual" (ManualRaBox, fixes-1b):
// the same read of the manual (manual_ra_scans lists its procedures with their pages - scanned pages too) and "Create checklist from
// this manual" makes one draft checklist per procedure, linked to the manual. Shown to a login with Edit on Checklists.
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { manualRaCall, pagesLabel } from './ManualRaBox'

const box = { border: '1px solid var(--line, var(--border))', borderRadius: 10, padding: 14, marginBottom: 14, background: 'var(--card, var(--hull))' }
const h = { fontSize: 11, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 8 }
const link = { background: 'none', border: 'none', padding: 0, color: 'var(--blue, #2563eb)', cursor: 'pointer', textDecoration: 'underline', font: 'inherit' }
function openChecklist(id) {
  try { localStorage.setItem('hc_open_checklist', String(id)) } catch (e) {}
  window.dispatchEvent(new CustomEvent('hc:navigate', { detail: { page: 'checklists' } }))
}

export default function ManualChecklistBox({ manual, clientId }) {
  const [lvl, setLvl] = useState(null)
  const [scan, setScan] = useState(undefined)
  const [busy, setBusy] = useState(false)
  const [out, setOut] = useState(null)
  const [err, setErr] = useState('')
  const ver = Number(manual.version) || 1
  const usable = manual.status === 'approved' && !manual.archived_at && !!manual.file_url
  const load = () => supabase.from('manual_ra_scans').select('version,pages,read_as,sections').eq('manual_id', manual.id).maybeSingle()
    .then(({ data, error }) => setScan(error ? null : (data && Number(data.version) === ver ? data : null)), () => setScan(null))
  useEffect(() => {
    let live = true
    supabase.rpc('my_perm', { p_client: String(clientId), p_module: 'checklists' }).then(({ data }) => { if (live) setLvl(Number(data) || 0) }, () => { if (live) setLvl(0) })
    load()
    return () => { live = false }
  }, [manual.id, clientId, ver]) // eslint-disable-line
  if (!usable || lvl == null || lvl < 2 || scan === undefined) return null
  const procs = scan ? (scan.sections || []).filter(s => s.kind === 'procedure') : []
  const make = async () => {
    setBusy(true); setErr(''); setOut(null)
    try { setOut(await manualRaCall('checklist_from_manual', manual.id)); load() } catch (e) { setErr(e.message || String(e)) }
    setBusy(false)
  }
  return (
    <div style={box} className="man-cl" data-testid="manual-checklists">
      <div style={h}>Checklists from this manual</div>
      {scan && scan.read_as !== 'error'
        ? (procs.length
          ? <ul style={{ margin: '0 0 8px', paddingLeft: 18, fontSize: 13 }}>{procs.map((s, i) => <li key={i}>{s.title} <span style={{ color: 'var(--muted)' }}>{'·'} {pagesLabel(s)}{s.scanned ? ' · scanned, read as an image' : ''}</span></li>)}</ul>
          : <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 8 }}>No procedure found in this manual.</div>)
        : <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 8 }}>Not read yet. The AI reads this manual’s own file and finds its procedures (launch and recovery, guest briefing, refuelling …).</div>}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <button type="button" className="btn" disabled={busy} onClick={make}>{busy ? 'Reading the manual…' : 'Create checklist from this manual'}</button>
        <span style={{ fontSize: 12, color: 'var(--muted)' }}>One draft checklist per procedure, linked to this manual. {busy ? 'This can take a minute or two.' : ''}</span>
      </div>
      {err && <div role="alert" style={{ marginTop: 8, fontSize: 13, color: 'var(--red)' }}>{err}</div>}
      {out && <div style={{ marginTop: 10, fontSize: 13 }} role="status">
        <div>{out.note}</div>
        {(out.created || []).length > 0 && <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>{out.created.map(c => <li key={c.id}><button type="button" style={link} onClick={() => openChecklist(c.id)}>{c.title}</button> <span style={{ color: 'var(--muted)' }}>{'·'} {c.steps} steps {'·'} {c.pages}</span></li>)}</ul>}
        {(out.failed || []).length > 0 && <ul style={{ margin: '6px 0 0', paddingLeft: 18, color: 'var(--red)' }}>{out.failed.map((f, i) => <li key={i}>{f.title} ({f.pages}): {f.error}</li>)}</ul>}
      </div>}
    </div>
  )
}
